// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + {"186":"bc948d6caf2eac318ab2","979":"e0469cbad6498940f011"}[chunkId] + ".js";
};